import React, { useState, useContext } from "react";
import style from "./ElementTechProces.module.css";
import iconX from "assets/xDark.svg";
import iconTrash from "assets/trash2.svg";
import { AppContext } from "context/AppContext";
import { ModalInsertContext } from "context/ModalInsertContext";
import { TechnologyContext } from "context/TechnologyContext";
import { reg_txt, reg_int } from "utils/initialvalue";
import { addNewProcessTech } from "actions/addNewProcessTech";
import { getNameOfProces } from "actions/getNameOfProces";

export default function ProcesElementTech() {
  const techContext = useContext(TechnologyContext);

  if (techContext.showElementyTechProcesyInsert) {
    return (
      <Window>
        <Header />
        <Table />
        <Footer />
      </Window>
    );
  }
  return null;
}

function Window({ children }) {
  return (
    <div className={style.blurContainer}>
      <div className={style.window}>{children}</div>
    </div>
  );
}

function Header() {
  const techContext = useContext(TechnologyContext);
  const appContext = useContext(AppContext);
  const rowElement = techContext.selectedElementTechROW || {};
  const typElementu = appContext.typ_elementu?.find((x) => x?.id == rowElement.typ)?.nazwa || "";

  return (
    <div className={style.header}>
      <div className={style.titleGroup}>
        <h2 className={style.title}>Procesy Technologia</h2>
        <span className={style.badge}>
          {typElementu} • {rowElement.naklad} szt. • {rowElement.nazwa}
        </span>
      </div>
      <Zamknij />
    </div>
  );
}

function Zamknij() {
  const techContext = useContext(TechnologyContext);
  return (
    <button
      className={style.closeBtn}
      onClick={() => techContext.setShowElementyTechProcesyInsert(false)}
      title="Zamknij"
    >
      <img src={iconX} alt="Zamknij" />
    </button>
  );
}

function Footer() {
  const techContext = useContext(TechnologyContext);

  return (
    <div className={style.footer}>
      <button
        className={style.btnCancel}
        onClick={() => techContext.setShowElementyTechProcesyInsert(false)}
      >
        Anuluj
      </button>
      <button
        className={style.btnSave}
        onClick={() => {
          techContext.setShowElementyTechProcesyInsert(false);
          techContext.setProcesyElementowTech(techContext.procesyElementowTechTemporary);
        }}
      >
        Zapisz zmiany
      </button>
    </div>
  );
}

function Table() {
  const techContext = useContext(TechnologyContext);
  const contexApp = useContext(AppContext);

  const {
    procesyElementowTechTemporary,
    setProcesyElementowTechTemporary,
    selectedElementTechROW
  } = techContext;

  const procesList = contexApp.procesList;
  const [draggedRowIndex, setDraggedRowIndex] = useState(null);

  const rows = (procesyElementowTechTemporary || [])
    .filter((x) => x.element_id == selectedElementTechROW?.id)
    .sort((a, b) => a.indeks - b.indeks)
    .filter((x) => x.delete !== true);

  const handleDropRow = (targetIndex) => {
    if (draggedRowIndex === null || draggedRowIndex === targetIndex) return;

    const updatedRows = [...rows];
    const [movedRow] = updatedRows.splice(draggedRowIndex, 1);
    updatedRows.splice(targetIndex, 0, movedRow);

    const reindexedRows = updatedRows.map((item, idx) => ({
      ...item,
      indeks: idx + 1,
      update: true
    }));

    const newTemporaryList = procesyElementowTechTemporary.map((item) => {
      const match = reindexedRows.find((r) => r.id === item.id);
      return match ? match : item;
    });

    setProcesyElementowTechTemporary(newTemporaryList);
    setDraggedRowIndex(null);
  };

  return (
    <div className={style.main}>
      <div className={style.tableWrapper}>
        <table className={style.table}>
          <thead>
            <tr>
              <th className={style.col_drag}></th>
              <th className={style.col_nr}>#</th>
              <th className={style.col_indeks}>Indeks</th>
              <th className={style.col_proces}>Proces</th>
              <th className={style.col_typ}>Typ / Wariant</th>
              <th className={style.col_ilosc}>Użytki</th>
              <th className={style.col_ilosc}>Front</th>
              <th className={style.col_ilosc}>Back</th>
              <th className={style.col_kolory}>Front kolory</th>
              <th className={style.col_kolory}>Back kolory</th>
              <th className={style.col_uwagi}>Uwagi</th>
              <th className={style.col_action}></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <ProcesTechRow
                key={row.id}
                row={row}
                i={i}
                index={i}
                draggedRowIndex={draggedRowIndex}
                setDraggedRowIndex={setDraggedRowIndex}
                handleDropRow={handleDropRow}
                procesyElementowTechTemporary={procesyElementowTechTemporary}
                setProcesyElementowTechTemporary={setProcesyElementowTechTemporary}
              />
            ))}
          </tbody>
        </table>
      </div>

      <div className={style.dodaj_proces_row}>
        <button
          className={style.btn_dodaj_proces}
          onClick={() =>
            addNewProcessTech(
              selectedElementTechROW,
              procesyElementowTechTemporary,
              setProcesyElementowTechTemporary,
              procesList
            )
          }
        >
          <span>+</span> Dodaj nowy proces
        </button>
      </div>
    </div>
  );
}

const ProcesTechRow = ({
  row,
  i,
  index,
  draggedRowIndex,
  setDraggedRowIndex,
  handleDropRow,
  procesyElementowTechTemporary,
  setProcesyElementowTechTemporary
}) => {
  const [procesID, setProcesID] = useState(row.nazwa_id);
  const [isDragOver, setIsDragOver] = useState(false);

  return (
    <tr
      draggable
      onDragStart={() => setDraggedRowIndex(index)}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDragOver(true);
      }}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={() => {
        setIsDragOver(false);
        handleDropRow(index);
      }}
      className={`${style.rowItem} ${draggedRowIndex === index ? style.dragging : ""} ${
        isDragOver ? style.dragOver : ""
      }`}
    >
      <td className={style.dragHandle} title="Przeciągnij, aby zmienić kolejność">
        ⋮⋮
      </td>
      <td className={style.cellNr}>{i + 1}</td>
      <INDEKS row={row} />
      <ProcesName row={row} setProcesID={setProcesID} />
      <ProcessTyp row={row} />
      <IloscUzytkow row={row} />
      <FrontIlosc row={row} />
      <BackIlosc row={row} />
      <FrontKolor row={row} />
      <BackKolor row={row} />
      <Info row={row} />
      <Usun
        row={row}
        procesyElementowTechTemporary={procesyElementowTechTemporary}
        setProcesyElementowTechTemporary={setProcesyElementowTechTemporary}
      />
    </tr>
  );
};

const ProcesName = ({ row, setProcesID }) => {
  const contexApp = useContext(AppContext);
  const techContext = useContext(TechnologyContext);
  const procesListName = contexApp.procesListName || [];
  const procesList = contexApp.procesList || [];

  return (
    <td>
      <select
        className={style.selectInput}
        value={row.nazwa_id || ""}
        onChange={(e) => {
          const newNazwaId = e.target.value;
          setProcesID(newNazwaId);

          const defaultProc = procesList.find((x) => x.nazwa_id == newNazwaId);

          if (defaultProc) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              ...defaultProc,
              nazwa_id: newNazwaId,
              nazwa: getNameOfProces(newNazwaId, procesListName),
              proces_id: defaultProc.id,
              update: true,
              id: row.id,
            });
          }
        }}
      >
        {procesListName.map((option) => (
          <option key={option.id} value={option.id}>
            {option.nazwa}
          </option>
        ))}
      </select>
    </td>
  );
};

const ProcessTyp = ({ row }) => {
  const contexApp = useContext(AppContext);
  const techContext = useContext(TechnologyContext);
  const procesList = contexApp.procesList || [];

  const dostepneTypy = procesList.filter((p) => p.nazwa_id == row.nazwa_id);

  return (
    <td>
      <select
        className={style.selectInput}
        value={row.proces_id || ""}
        onChange={(e) => {
          const selectedId = e.target.value;
          const proc = procesList.find((x) => x.id == selectedId);

          if (proc) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              ...proc,
              proces_id: selectedId,
              update: true,
              id: row.id,
            });
          }
        }}
      >
        {dostepneTypy.map((option) => (
          <option key={option.id} value={option.id}>
            {[option.typ, option.rodzaj, option.wykonczenie, option.obszar].filter(Boolean).join(" ")}
          </option>
        ))}
      </select>
    </td>
  );
};

const INDEKS = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={`${style.textInput} ${style.inputCenter}`}
        value={row.indeks}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              indeks: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const IloscUzytkow = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={`${style.textInput} ${style.inputCenter}`}
        value={row.ilosc_uzytkow}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              ilosc_uzytkow: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const FrontIlosc = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={`${style.textInput} ${style.inputCenter}`}
        value={row.front_ilosc}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              front_ilosc: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const BackIlosc = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={`${style.textInput} ${style.inputCenter}`}
        value={row.back_ilosc}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              back_ilosc: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const FrontKolor = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={style.textInput}
        value={row.front_kolor || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              front_kolor: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const BackKolor = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={style.textInput}
        value={row.back_kolor || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              back_kolor: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

const Info = ({ row }) => {
  const techContext = useContext(TechnologyContext);
  return (
    <td>
      <input
        className={style.textInput}
        value={row.info || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            techContext.handleUpdateRowProcesyElementowTech({
              ...row,
              info: e.target.value,
              update: true,
            });
          }
        }}
      />
    </td>
  );
};

function Usun({ row }) {
  const techContext = useContext(TechnologyContext);
  const { grupaWykonan, procesyElementowTechTemporary, setProcesyElementowTechTemporary } = techContext;

  const handleRemove = () => {
    const isUsed = grupaWykonan?.some(
      (x) =>
        parseInt(x.global_proces_id) === parseInt(row.proces_id) &&
        parseInt(x.element_id) === parseInt(row.element_id)
    );

    if (isUsed) {
      alert("Najpierw skasuj grupy wykonań połączone z tym procesem.");
      return;
    }

    setProcesyElementowTechTemporary(
      procesyElementowTechTemporary.map((t) =>
        t.id === row.id ? { ...t, delete: true } : t
      )
    );
  };

  return (
    <td className={style.cellAction}>
      <button className={style.deleteBtn} onClick={handleRemove} title="Usuń proces">
        <img src={iconTrash} alt="Usuń" />
      </button>
    </td>
  );
}